import { render, staticRenderFns } from "./StagingEditor.vue?vue&type=template&id=0696bd9a"
import script from "./StagingEditor.vue?vue&type=script&lang=ts"
export * from "./StagingEditor.vue?vue&type=script&lang=ts"
import style0 from "./StagingEditor.vue?vue&type=style&index=0&id=0696bd9a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports